import { Link } from "react-router-dom";
import { hotContent } from "@/mocks/home";

export default function HotContent() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              热门综艺
            </h2>
            <p className="text-sm text-foreground-600">
              全网最火的综艺节目，大家都在看
            </p>
          </div>
          <Link
            to="/category/remen"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors no-underline flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {hotContent.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={show.image}
                  alt={show.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  title={`${show.title} - 6789影视`}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary-500 text-white">
                    {show.badge}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-black/60 text-white text-xs">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  {show.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-white text-xs font-medium">
                    {show.episode}
                  </span>
                </div>
              </div>

              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-primary-500 font-medium mb-1">
                  {show.category}
                </span>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {show.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3 flex-1">
                  {show.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {show.views}
                  </span>
                  <span>{show.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}